import Affix from './Affix'
import Anchor from './Anchor'
import AutoComplete from './AutoComplete'
import Badge from './Badge'
import Button from './Button'
import Checkbox from './Checkbox'
import Cascader from './Cascader'
import Collapse from './Collapse'
import CarouselFigure from './Carousel'
import Layout from './Layout'
import Row from './Row'
import Col from './Col'
import Con from './_Con'
import Card from './Card'
import Dropdown from './Dropdown'
import DatePicker from './DatePicker'
import Dnd from './Dnd'
import Form from './Form'
import Icon from './Icon'
import Input from './Input'
import InputNumber from './InputNumber'
import Loading from './Loading'
import Menu from './Menu'
import Modal from './Modal'
import MobileLocale from './MobileLocale'
import Message from './Message'
import Notification from './Notification'
import Popover from './Popover'
import Progress from './Progress'
import Popconfirm from './Popconfirm'
import Pagination from './Pagination'
import Radio from './Radio'
import Switch from './Switch'
import Select from './Select'
import Slider from './Slider'
import Steps from './Steps'
import Tabs from './Tabs'
import Tag from './Tag/simple'
import YonUITag from './Tag'
import TimePicker from './TimePicker'
import Tree from './Tree'
import TreeSelect from './TreeSelect'
import Upload from './Upload'
import Tooltip from './Tooltip'
// 无法兼容组件导出两个
import FormControl from './FormControl'
import BeeCheckbox from './BeeCheckbox'
import BeeRadio from './BeeRadio'
import BeeCollapse from './BeeCollapse'
import BeeLoading from './BeeLoading'
import BeeIcon from './BeeIcon'
import BeeModal from './BeeModal'
import BeeButton from './BeeButton'
import BeeTabs from './BeeTabs'
import BeePopconfirm from './BeePopconfirm'
// 部分tinper组件导出
import Transfer from './Transfer'
// import Grid from './Grid';
import Panel from './Panel'
import Timeline from './Timeline'
import ProgressBar from './ProgressBar'
import ButtonGroup from './ButtonGroup'
import Label from './Label'
import SearchPanel from './SearchPanel'
import Tile from './Tile'
import Drawer from './Drawer'
// import SvgIcon from './SvgIcon';
import PageLayout from './PageLayout'
import Clipboard from './Clipboard'
import ColorPicker from './ColorPicker'
import LoadingState from './LoadingState'
import Viewer from './Viewer'
import Breadcrumb from './Breadcrumb'
import Navbar from './Navbar'
import Backtop from './Backtop'
import Alert from './Alert'
import InputGroup from './InputGroup'
import FormGroup from './FormGroup'
import Rate from './Rate'
import Table from './Table'
import BeeLocale from './Locale'

export {
  Affix,
  Anchor,
  AutoComplete,
  Button,
  Badge,
  Checkbox,
  Card,
  Layout,
  Col,
  Con,
  Collapse,
  Cascader,
  CarouselFigure,
  Dropdown,
  DatePicker,
  Dnd,
  Form,
  Input,
  InputNumber,
  Icon,
  Loading,
  Message,
  Modal,
  Menu,
  Notification as notification,
  Notification,
  Pagination,
  Popconfirm,
  Popover,
  Progress,
  Row,
  Radio,
  Select,
  Slider,
  Switch,
  Steps,
  Tag,
  YonUITag,
  Tabs,
  // Grid,
  TimePicker,
  Tree,
  TreeSelect,
  Transfer,
  Upload,
  Tooltip,
  MobileLocale,
  ProgressBar,
  Timeline,
  Panel,
  ButtonGroup,
  Label,
  SearchPanel,
  Tile,
  FormControl,
  BeeCheckbox,
  BeeRadio,
  BeeCollapse,
  BeeLoading,
  BeeButton,
  // SvgIcon,
  PageLayout,
  Clipboard,
  ColorPicker,
  LoadingState,
  Viewer,
  Breadcrumb,
  Navbar,
  Backtop,
  Alert,
  Drawer,
  InputGroup,
  FormGroup,
  Rate,
  Table,
  BeeModal,
  BeeIcon,
  BeeLocale,
  BeeTabs,
  BeePopconfirm
}
